<template>
    <div class="container">
        <div class="text-uppercase h2 mb-0 text-end">
            {{ today }}
        </div>
        <div class="row mt-3" v-if="getFullList">
            <div class="col-12">
                <h2 class="text-orange display-6">VIP</h2>
            </div>
            <div class="col-md-6">
                <TransportCard
                    v-for="(vipItem, index) in vip.slice(0, 5)"
                    :item="vipItem"
                    :priority="index+1"
                />
            </div>
            <div class="col-md-6">
                <TransportCard
                    v-for="(vipItem, index) in vip.slice(5)"
                    :item="vipItem"
                    :priority="index+1+5"
                />
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <h2 class="text-orange display-6" v-if="isMonitor">
                    {{ $t('queue.normal') }} | {{ $t('queue.normal', null, {locale: 'en'}) }}
                </h2>
                <h2 class="text-orange display-6" v-else>
                    NORMAL
                </h2>
            </div>
            <div class="col-md-6">
                <TransportCard
                    v-for="(normalItem, index) in normal.slice(0,5)"
                    :item="normalItem"
                    :priority="index+1"
                />
            </div>
            <div class="col-md-6">
                <TransportCard
                    v-for="(normalItem, index) in normal.slice(5)"
                    :item="normalItem"
                    :priority="index+1+5"
                />
            </div>
        </div>
    </div>
</template>

<script>
import MerchantLayout from "../../../Layouts/MerchantLayout.vue";
import TransportCard from "../../../components/TransportCard.vue";
import { router } from "@inertiajs/vue3";

export default {
    name: "List",
    layout: MerchantLayout,
    props: {
        normal: Object,
        vip: Object,
        user: Object,
        today: String,
    },
    computed: {
        getFullList() {
            return ['Super', 'Moderator'].includes(this.user.role);
        },
        isMonitor(){
            return ['Monitor'].includes(this.user.role);
        }
    },
    created() {
        this.vipItems = this.vip
        this.normalItems = this.normal
    },
    mounted() {
        this.$echo
            .private('update-queue')
            .listen('UpdateQueueEvent',(e) => {
                router.get('/merchant/queue',{}, {
                    only: [e.queue_type]
                })
            });
    },
    components: {TransportCard},
}
</script>

<style scoped>

</style>
